import React from "react";

function TokenLSer() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Token Listing Services with Xeer Technology
              </h2>
              <p>
                Expand your token’s reach with a smooth, strategic listing
                process designed to bring credibility and visibility to your
                project. At Xeer Technology, we provide complete support to
                guide you through every stage of the token listing journey,
                enhancing your token’s market presence and ensuring alignment
                with regulatory standards.
              </p>
              {/* <p>
                With our ready-made solution, you can quickly launch your own
                branded wallet, tailored to meet the needs of your customers
                while saving valuable development time and costs. Whether you're
                looking to improve customer loyalty, expand your service
                offerings, or tap into new revenue streams, our White Label
                Crypto Wallet is designed to help you succeed.
              </p> */}
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TokenLSer;
